import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link as ReactRouterLink } from 'react-router-dom'
import { getRedirects } from '../../selectors/entitySelectors'

const matchRedirect = (redirects = {}, to) => {
  if (!to || !to.startsWith('/')) {
    return null
  }

  let slug = to
  if (to.includes('?')) {
    slug = to.substr(0, to.indexOf('?'))
  }

  return redirects[slug]
}

const Link = ({ to, children, dispatch, ...restProps }) => {
  if (to && to.startsWith('http')) {
    // If the url starts with `http` we use an `<a>` element for external routing
    return (
      <a href={to} {...restProps}>
        {children}
      </a>
    )
  }

  const { className, target, disabled } = restProps

  let prefix = ''
  // If the route is internal and the url is not prefixed with a slash, we add it here
  if (to && !to.startsWith('/')) prefix = '/'

  return (
    <ReactRouterLink
      className={`${className} ${disabled ? 'disabled' : ''}`}
      // hrefLang={hrefLang || trans('locale')}
      target={target}
      to={`${prefix}${to}`}
    >
      {children}
    </ReactRouterLink>
  )
}

Link.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  hrefLang: PropTypes.string,
  target: PropTypes.string,
  to: PropTypes.string,
  disabled: PropTypes.bool
}

const mapState = (state, ownProps) => {
  const redirects = getRedirects(state)
  const redirect = matchRedirect(redirects, ownProps.to)

  return {
    to: redirect ? redirect.target : ownProps.to
  }
}

export default connect(mapState)(Link)
